export * from '@fhs/routing/src/routes/rewards/details';
export { default } from '@fhs/routing/src/routes/rewards/details';
